import type { AppConfiguration } from '../AppConfiguration';

export const appConfigurationMock: AppConfiguration = {
  currentLanguage: 'en-GB',
  customerId: -1,
  globalApiUrl: 'https://we-test-api.oriflame.com/uat',
  graphqlUrl: 'https://graphql-we-uat.oriflame.com/',
  identityUrl: 'https://identity-uat.oriflame.com/',
  staticApiUrl: 'https://api-uat-static.oriflame.com/',
  tenant: 'uk',
};
